import { defineComponent } from 'vue'
import classNames from 'classnames'
import './CustomTableLayout.scss'

export const CustomTableLayout = defineComponent({
  name: 'CustomTableLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('custom-table-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
